import { TFunction } from "i18next";
import { TaxonomyState } from "../store/taxonomy";
import { ExpandedColumn } from "../types/columns";
import { Fleet, Insurer, VehicleAzure } from "../types/types";

export const transformFleetsForExcel = ({
  fleets,
  columns,
  t,
  taxonomy,
}: {
  fleets: Fleet[];
  columns: any[];
  t: TFunction;
  taxonomy: TaxonomyState;
}) => {
  return fleets.map((fleet) => {
    return columns
      .filter((c) => c.excel?.isVisible !== false)
      .reduce((acc, c) => {
        if (c.excel && c.excel.render) {
          acc[c.key] = c.excel.render({
            t,
            taxonomy,
            insurerList: [],
            row: fleet,
          });
        } else {
          acc[c.key] = fleet[c.key];
        }
        return acc;
      }, {});
  });
};

export const transformVehiclesForExcel = ({
  vehicles,
  columns,
  t,
  taxonomy,
  insurerList,
}: {
  vehicles: VehicleAzure[];
  columns: ExpandedColumn[];
  t: TFunction;
  taxonomy: TaxonomyState;
  insurerList: Insurer[];
}) => {
  return vehicles.map((v) => {
    return columns
      .filter((c) => c.isVisible)
      .reduce((transformedVehicle, c) => {
        if (c.excel && c.excel.render) {
          transformedVehicle[c.key] = c.excel.render({
            t,
            taxonomy,
            insurerList,
            row: v,
          });
        }
        //
        else {
          transformedVehicle[c.key] = v[c.key];
        }
        return transformedVehicle;
      }, {});
  });
};
